import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";

export default function MemberHome() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null) return;
    if (user === false) { navigate("/"); return; }
    if (user.role === "admin") { navigate("/admin"); return; }
  }, [user, navigate]);

  if (!user || user === false) {
    return (
      <div
        className="min-h-screen flex items-center justify-center text-xs uppercase tracking-[0.3em] text-neutral-400"
        style={{ background: "radial-gradient(ellipse at 50% 0%, #2a2a2a 0%, #141414 40%, #050505 80%, #000000 100%)" }}
      >
        Loading…
      </div>
    );
  }

  return (
    <div
      data-testid="member-home"
      className="min-h-screen w-full text-neutral-300 flex flex-col relative overflow-hidden"
      style={{
        background: "radial-gradient(ellipse at 50% 0%, #2a2a2a 0%, #141414 40%, #050505 80%, #000000 100%)",
      }}
    >
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="absolute top-0 right-0 p-6 z-30 flex items-center gap-4 text-[10px] uppercase tracking-[0.25em]"
      >
        <span data-testid="user-email" className="text-neutral-400 hidden sm:inline">{user.email}</span>
        <button
          data-testid="logout-btn"
          onClick={async () => { await logout(); navigate("/"); }}
          className="border border-neutral-500 text-neutral-300 px-4 py-2 hover:bg-neutral-200 hover:text-black transition-colors"
        >
          Sign Out
        </button>
      </motion.div>

      <main className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="w-full max-w-5xl flex flex-col sm:flex-row items-center justify-center gap-12 sm:gap-24" data-testid="member-tabs">
          <Link
            to="/member/profile"
            data-testid="profile-link"
            className="group inline-flex items-center gap-5 uppercase tracking-[0.4em] hover:opacity-60 transition-opacity text-neutral-100"
            style={{
              fontFamily: "'Archivo', system-ui, sans-serif",
              fontSize: "clamp(28px, 5vw, 44px)",
              fontWeight: 300,
            }}
          >
            <span>Profile</span>
            <span className="inline-block transition-transform group-hover:translate-x-2" aria-hidden>→</span>
          </Link>
          <Link
            to="/member/request"
            data-testid="request-link"
            className="group inline-flex items-center gap-5 uppercase tracking-[0.4em] hover:opacity-60 transition-opacity text-neutral-100"
            style={{
              fontFamily: "'Archivo', system-ui, sans-serif",
              fontSize: "clamp(28px, 5vw, 44px)",
              fontWeight: 300,
            }}
          >
            <span>Request</span>
            <span className="inline-block transition-transform group-hover:translate-x-2" aria-hidden>→</span>
          </Link>
        </div>
      </main>

      <footer
        data-testid="site-footer"
        className="w-full px-6 pb-6 pt-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-[10px] uppercase tracking-[0.3em] text-neutral-500"
      >
        <div>© 2026 Wellnet</div>
        <div className="flex gap-6">
          <Link to="/member/history" className="hover:text-neutral-300 transition-colors">History</Link>
          <a href="/support" className="hover:text-neutral-300 transition-colors">Support</a>
          <a href="/privacy" className="hover:text-neutral-300 transition-colors">Privacy</a>
        </div>
      </footer>
    </div>
  );
}
